const o = {
  id: "MinnesotaPick3",
  logo: !0,
  name: "Pick 3",
  style: {
    colorPrimary: "#0069b5"
  }
};
export {
  o as default
};
